import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

/*
 * Кнопки «Реестр» и «Рейтинг» видны всем, но открываются только с правом управления ППУ,
 * а ветка в настройки открывает страницу до поиска якоря — поэтому права проверяем заранее.
 */
export const improvementsConditions: Record<string, () => boolean> = {
  'improvements.canManage': () => Boolean(usePermissionsStore().modules.improvements?.manage),
}
